import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class RestService {

  constructor(
    public http: HttpClient
  ) { }

  // TODO : change url to production
  // private endpoint: string = "http://localhost:3000";
  private endpoint: string = "https://noc-api.syrinx.dev"

  login(username: any, password: any) {
    const body: any = { "username": username, "password": password };

    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
      // .set("Content-Type", "application/x-www-form-urlencoded");

      this.http.post(this.endpoint + '/login', body, { headers }).subscribe(returnData => {
        // console.log(returnData);
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getUsers(auth_token: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/users', { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  delUser(auth_token: any, userId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.delete(this.endpoint + '/user/' + userId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  putUser(auth_token: any, user: any, userId : any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.put(this.endpoint + '/user/' + userId, user, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  postUser(auth_token: any, user: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.post(this.endpoint + '/user', user, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getUser(auth_token: any, userId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/user/' + userId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getDevices(auth_token: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/devices', { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  postDevice(auth_token: any, device: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.post(this.endpoint + '/devices', device, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  delDevice(auth_token: any, deviceId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.delete(this.endpoint + '/devices/' + deviceId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  putDevice(auth_token: any, device: any, deviceId : any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.put(this.endpoint + '/devices/' + deviceId, device, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getDevice(auth_token: any, deviceId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/devices/' + deviceId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getScenarios(auth_token: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/scenarios', { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getScenario(auth_token: any, scenarioId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/scenarios/' + scenarioId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  putScenario(auth_token: any, scenario: any, scenarioId : any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.put(this.endpoint + '/scenarios/' + scenarioId, scenario, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  delScenario(auth_token: any, scenatioId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.delete(this.endpoint + '/scenarios/' + scenatioId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  postScenario(auth_token: any, scenario: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.post(this.endpoint + '/scenarios', scenario, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getDepartments(auth_token: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/departments', { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getAssignedScenarios(auth_token: any, deviceId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/scenarios/assigned/' + deviceId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  postAssignedScenarios(auth_token: any, data: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.post(this.endpoint + '/scenarios/assigned/', data , { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  delAssignedScenarios(auth_token: any, scenarioId: any, deviceId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.delete(this.endpoint + '/scenarios/assigned/' + scenarioId + '/' + deviceId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  putAssignedScenarios(auth_token: any, scenario: any, scenarioId : any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.put(this.endpoint + '/scenarios/assigned/' + scenarioId, scenario, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  getScenariosToAssign(auth_token: any, deviceId: any) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.get(this.endpoint + '/scenarios/assigned/free/' + deviceId, { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }

  postPlayScenario(auth_token: any, deviceMac: any, scenario : any) {
    return new Promise((resolve, reject) => {
      console.log(deviceMac, scenario)
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + auth_token)
        .set("Content-Type", "application/json");

      this.http.post(this.endpoint + '/playscenario/'+ deviceMac, scenario , { headers }).subscribe(returnData => {
        resolve(returnData);
      }, (err) => {
        reject(err);
      })
    })
  }
}
